var _g, _path, _g2, _g3, _g4, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSpeedchainLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint0_diamond_549_63587_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.000491364 0.0304748 -0.0196544 0.000761876 14.847 -5.97238)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 711.116,
    height: 302.538,
    fill: "url(#paint0_diamond_549_63587)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 711.116,
    height: 302.538,
    transform: "scale(1 -1)",
    fill: "url(#paint0_diamond_549_63587)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 711.116,
    height: 302.538,
    transform: "scale(-1 1)",
    fill: "url(#paint0_diamond_549_63587)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 711.116,
    height: 302.538,
    transform: "scale(-1)",
    fill: "url(#paint0_diamond_549_63587)",
    opacity: 1,
    shapeRendering: "crispEdges"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3163 0.848372C14.5946 0.681101 15.6884 0.939611 16.677 1.7218C19.2475 3.75281 21.1031 6.24668 18.4924 9.15017C16.8989 10.9217 14.8243 12.4965 13.1955 14.2624L13.0099 14.3441L10.6978 12.0461L16.0222 6.7675C16.4728 5.3666 14.2706 3.51046 13.0099 4.69562L10.6978 2.46596C11.2181 1.68663 12.3659 0.971925 13.3163 0.848372Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":0.98272889852523804,\"m01\":-39.308860778808594,\"m02\":34.010086059570312,\"m10\":60.949653625488281,\"m11\":1.5237525701522827,\"m12\":-37.209083557128906},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_549_63587)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint1_diamond_549_63587_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.000762805 0.0196845 -0.030512 0.000492115 12.1284 5.8161)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 730.988,
    height: 282.529,
    fill: "url(#paint1_diamond_549_63587)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 730.988,
    height: 282.529,
    transform: "scale(1 -1)",
    fill: "url(#paint1_diamond_549_63587)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 730.988,
    height: 282.529,
    transform: "scale(-1 1)",
    fill: "url(#paint1_diamond_549_63587)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 730.988,
    height: 282.529,
    transform: "scale(-1)",
    fill: "url(#paint1_diamond_549_63587)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M7.98644 10.1914L12.9407 14.9681C14.3997 16.3985 17.0516 13.8847 15.6957 12.4258L17.9951 10.1914C19.9676 11.6541 20.3574 14.1308 18.7334 16.0088C16.9642 18.055 14.6667 19.9692 11.8303 18.3069L5.68701 12.4933L7.98545 10.1904L7.98644 10.1914Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":1.5256109237670898,\"m01\":-61.023983001708984,\"m02\":41.877613067626953,\"m10\":39.368934631347656,\"m11\":0.9842306375503540,\"m12\":-14.360479354858398},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_549_63587)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint2_diamond_549_63587_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.000491373 0.0305183 -0.0196548 0.000762964 5.09123 -1.41613)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 711.063,
    height: 302.536,
    fill: "url(#paint2_diamond_549_63587)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 711.063,
    height: 302.536,
    transform: "scale(1 -1)",
    fill: "url(#paint2_diamond_549_63587)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 711.063,
    height: 302.536,
    transform: "scale(-1 1)",
    fill: "url(#paint2_diamond_549_63587)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 711.063,
    height: 302.536,
    transform: "scale(-1)",
    fill: "url(#paint2_diamond_549_63587)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M7.59662 5.36572L9.89506 7.66856C9.23037 8.26066 8.66287 8.94875 8.0404 9.57602C7.19309 10.4304 5.66145 11.5757 4.99773 12.4139C4.48228 13.065 4.40079 13.6732 4.94373 14.3528C5.57308 15.1406 6.69334 15.9276 7.59563 15.0152L9.99815 17.3304C8.764 18.7123 6.9172 19.331 5.09493 18.6533C4.11704 18.2903 1.59572 15.8601 1.2187 14.9173C0.75921 13.7692 0.875065 12.4044 1.54172 11.3523C3.40424 9.22627 5.59566 7.37488 7.59563 5.36667L7.59662 5.36572Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":0.98274606466293335,\"m01\":-39.309551239013672,\"m02\":24.254632949829102,\"m10\":61.036682128906250,\"m11\":1.5259282588958740,\"m12\":-32.697437286376953},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#paint3_diamond_549_63587_clip_path)",
    "data-figma-skip-parse": "true"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.000755452 0.0196491 -0.0302179 0.000491231 7.32121 -3.573)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 731.101,
    height: 282.894,
    fill: "url(#paint3_diamond_549_63587)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 731.101,
    height: 282.894,
    transform: "scale(1 -1)",
    fill: "url(#paint3_diamond_549_63587)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 731.101,
    height: 282.894,
    transform: "scale(-1 1)",
    fill: "url(#paint3_diamond_549_63587)",
    opacity: 1,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 731.101,
    height: 282.894,
    transform: "scale(-1)",
    fill: "url(#paint3_diamond_549_63587)",
    opacity: 1,
    shapeRendering: "crispEdges"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8551 0.847251C6.95081 0.682831 8.12703 0.890019 9.01263 1.542L14.8162 7.11232L14.8653 7.35088L12.6022 9.5254L7.49867 4.60896C6.25568 3.63004 4.38433 5.36073 4.61015 6.63807C4.66317 6.9403 4.98521 7.07621 4.85364 7.34993L2.59251 9.52636C1.22287 8.39062 0.604327 6.79869 1.12567 5.08511C1.53215 3.74789 4.39513 1.06584 5.8551 0.847251Z",
    "data-figma-gradient-fill": "{\"type\":\"GRADIENT_DIAMOND\",\"stops\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":1.0},\"position\":1.0}],\"stopsVar\":[{\"color\":{\"r\":1.0,\"g\":1.0,\"b\":1.0,\"a\":1.0},\"position\":0.0},{\"color\":{\"r\":0.0,\"g\":0.0,\"b\":0.0,\"a\":1.0},\"position\":1.0}],\"transform\":{\"m00\":1.5109038352966309,\"m01\":-60.435703277587891,\"m02\":36.783611297607422,\"m10\":39.298152923583984,\"m11\":0.98246109485626221,\"m12\":-23.713312149047852},\"opacity\":1.0,\"blendMode\":\"NORMAL\",\"visible\":true}"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "paint0_diamond_549_63587_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3163 0.848372C14.5946 0.681101 15.6884 0.939611 16.677 1.7218C19.2475 3.75281 21.1031 6.24668 18.4924 9.15017C16.8989 10.9217 14.8243 12.4965 13.1955 14.2624L13.0099 14.3441L10.6978 12.0461L16.0222 6.7675C16.4728 5.3666 14.2706 3.51046 13.0099 4.69562L10.6978 2.46596C11.2181 1.68663 12.3659 0.971925 13.3163 0.848372Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_549_63587",
    x: 5.68701,
    y: 10.1904,
    width: 14.0591,
    height: 8.74854,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_549_63587"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_549_63587",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint1_diamond_549_63587_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.98644 10.1914L12.9407 14.9681C14.3997 16.3985 17.0516 13.8847 15.6957 12.4258L17.9951 10.1914C19.9676 11.6541 20.3574 14.1308 18.7334 16.0088C16.9642 18.055 14.6667 19.9692 11.8303 18.3069L5.68701 12.4933L7.98545 10.1904L7.98644 10.1914Z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_549_63587",
    x: 0.941895,
    y: 5.36572,
    width: 9.05615,
    height: 13.5637,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_549_63587"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_549_63587",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint2_diamond_549_63587_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.59662 5.36572L9.89506 7.66856C9.23037 8.26066 8.66287 8.94875 8.0404 9.57602C7.19309 10.4304 5.66145 11.5757 4.99773 12.4139C4.48228 13.065 4.40079 13.6732 4.94373 14.3528C5.57308 15.1406 6.69334 15.9276 7.59563 15.0152L9.99815 17.3304C8.764 18.7123 6.9172 19.331 5.09493 18.6533C4.11704 18.2903 1.59572 15.8601 1.2187 14.9173C0.75921 13.7692 0.875065 12.4044 1.54172 11.3523C3.40424 9.22627 5.59566 7.37488 7.59563 5.36667L7.59662 5.36572Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "paint3_diamond_549_63587_clip_path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.8551 0.847251C6.95081 0.682831 8.12703 0.890019 9.01263 1.542L14.8162 7.11232L14.8653 7.35088L12.6022 9.5254L7.49867 4.60896C6.25568 3.63004 4.38433 5.36073 4.61015 6.63807C4.66317 6.9403 4.98521 7.07621 4.85364 7.34993L2.59251 9.52636C1.22287 8.39062 0.604327 6.79869 1.12567 5.08511C1.53215 3.74789 4.39513 1.06584 5.8551 0.847251Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_diamond_549_63587",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_diamond_549_63587",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_diamond_549_63587",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_diamond_549_63587",
    x1: 0,
    y1: 0,
    x2: 500,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedchainLogoMobile);
export default __webpack_public_path__ + "static/media/speedchain-logo-mobile.7da87905c9c9a1152cc91a8fb89cdd87.svg";
export { ForwardRef as ReactComponent };